import Layout from '@/layout';

import Monitor from './monitor.js';
import Record from './record.js';
import Statistics from './statistics.js';

export { Monitor, Record, Statistics };

export const CottonRoutes = {
  path: '/cotton',
  component: Layout,
  redirect: '/cotton/project-selection',
  meta: {
    title: '实时监控',
    icon: 'iconfont icon-shexiangtou',
    code: '010211'
  },
  children: [
    {
      path: 'page',
      name: 'cottonIndex',
      redirect: '/cotton/page/monitor',
      component: () => import('@/views/cotton/index.vue'),
      meta: {
        activeMenu: '/cotton',
        noPadding: true
      },
      children: [...Monitor, ...Record, ...Statistics]
    },
    {
      path: 'project-selection',
      name: 'cottonProjectSelection',
      component: () => import('@/views/cotton/projectSelection/index.vue'),
      meta: {
        activeMenu: '/cotton',
        hidden: true,
        noPadding: true
      }
    },
    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
};
